import React from "react";
import "./Dashboard.css";
import transcriptionIcon from "../assets/transcription.svg";
import redactionIcon from "../assets/redaction.svg";
import summarizationIcon from "../assets/summarization.svg";
import videoConversionIcon from "../assets/video-conversion.svg";
import sharingIcon from "../assets/sharing.svg";

export default function Dashboard() {
  const tools = [
    {
      name: "Transcription",
      description: "Convert speech to text for fast transcription.",
      usage: { used: 3, total: 5 },
      icon: transcriptionIcon,
      onClick: () => alert("Launching Transcription Tool..."),
    },
    {
      name: "Redaction",
      description: "Blur or remove sensitive information automatically.",
      usage: { used: 1, total: 4 },
      icon: redactionIcon,
      onClick: () => alert("Launching Redaction Tool..."),
    },
    {
      name: "Summarization",
      description: "Generate concise summaries of videos or documents.",
      usage: { used: 2, total: 3 },
      icon: summarizationIcon,
      onClick: () => alert("Launching Summarization Tool..."),
    },
    {
      name: "Secure Sharing",
      description: "Grant temporary, trackable access to your evidence files.",
      usage: { used: 4, total: 6 },
      icon: sharingIcon,
      onClick: () => alert("Launching Secure Sharing Tool..."),
    },
    {
    name: "Video Conversion",
    description: "Convert a wide range of video files into a common format.",
    usage: { used: 2, total: 5 },
    icon: videoConversionIcon,
    onClick: () => alert("Launching Video Conversion Tool..."),
    },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-grid">
        {tools.map((tool) => {
          const percentageRemaining = ((tool.usage.total - tool.usage.used) / tool.usage.total) * 100;

          // Determine color based on usage left
          const meterColor =
            percentageRemaining < 50 ? "#4caf50" : // Green
            "#ff9800" // Orange

          return (
            <div key={tool.name} className="tool-card" onClick={tool.onClick}>
              <img src={tool.icon} alt={tool.name} className="tool-icon" />
              <h3 className="tool-name">{tool.name}</h3>
              <p className="tool-description">{tool.description}</p>

              {/* Subtle Circular Meter (Smaller, Less Contrast, Bottom Right) */}
              <div className="circular-meter">
                <svg width="40" height="40">
                  <circle cx="20" cy="20" r="16" stroke="#e0e0e0" strokeWidth="4" fill="none" />
                  <circle
                    cx="20"
                    cy="20"
                    r="16"
                    stroke={meterColor}
                    strokeWidth="4"
                    fill="none"
                    strokeDasharray="100"
                    strokeDashoffset={(percentageRemaining / 100) * 100}
                    strokeLinecap="round"
                    transform="rotate(-90 20 20)"
                  />
                  <text x="50%" y="55%" textAnchor="middle" fontSize="10px" fontWeight="bold" fill="#555">
                    {tool.usage.used}/{tool.usage.total}
                  </text>
                </svg>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
